import React, { useState } from 'react';
import { MutationStatus, useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';
import { CandidateProfileFormData } from '../../../models';
import { useAuth } from '../logic/auth';
import {
  CreateCandidateFormLocationState,
  useCreateCandidateForm,
} from '../logic/useCreateCandidateForm';
import CandidateProfileForm from './CandidateProfileForm';
import { GET_USER_DETAILS_QUERY_KEY } from '../../../constants/queryKeys';

interface CreateCandidateFormProps {
  onSubmitCallback?: (isSingPassUser?: boolean) => void;
  isHideExtraFormInfo?: boolean;
}

const CreateCandidateForm = ({
                               onSubmitCallback = () => null,
                               isHideExtraFormInfo = false,
                             }: CreateCandidateFormProps) => {
  const history = useHistory();
  const auth = useAuth();

  const { state } = useLocation<CreateCandidateFormLocationState>();
  const isDisableInputs = state?.formData?.formDataIsDisabled;

  const queryClient = useQueryClient();

  const [apiButtonStatus, setApiButtonStatus] = useState<MutationStatus>('idle');

  const { createCandidate, submitError } = useCreateCandidateForm(() => {
    if (state?.credentialType === 'SINGPASS') {
      // call get user details API to update login status because create candidate API will return new login cookies
      queryClient.invalidateQueries(GET_USER_DETAILS_QUERY_KEY).then(() => null);
      auth.signin();
      history.push('/');
    }
    onSubmitCallback(state?.credentialType !== 'USERNAME');
  }, setApiButtonStatus);

  return (
      <CandidateProfileForm
          isHideEditButton
          defaultEditState
          isCreate
          onCallHandleSubmit={(formData: CandidateProfileFormData) => {
            let birthDate;
            if (formData.dateOfBirth) {
              birthDate = new Date(formData.dateOfBirth);
              const offset = birthDate.getTimezoneOffset();
              birthDate = new Date(birthDate.getTime() - offset * 60 * 1000);
            }
            let nationalityIssueDate;
            if (formData.nationalityIssueDate) {
              nationalityIssueDate = new Date(formData.nationalityIssueDate);
              const offset = nationalityIssueDate.getTimezoneOffset();
              nationalityIssueDate = new Date(nationalityIssueDate.getTime() - offset * 60 * 1000);
            }
            createCandidate(
                {
                  ...formData,
                  name: state?.formData?.formDataDefaultValues?.name || formData.name,
                  NricFin: state?.formData?.formDataDefaultValues?.NricFin || formData.NricFin,
                  dateOfBirth: birthDate ? birthDate.toISOString() : formData.dateOfBirth,
                  nationalityIssueDate: nationalityIssueDate
                      ? nationalityIssueDate.toISOString()
                      : formData.nationalityIssueDate,
                  secondaryRace: state?.formData?.formDataDefaultValues.secondaryRace ?? '',
                },
                state?.credentialType
            );
          }}
          formDefaultValues={state?.formData?.formDataDefaultValues}
          isDisableInputs={isDisableInputs}
          isHideExtraFormInfo={isHideExtraFormInfo}
          ApiButtonStatus={apiButtonStatus}
          submitError={submitError}
      />
  );
};

export default CreateCandidateForm;
